import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import introJs from "intro.js";

const renderChevron = (isExpanded, intro = null) =>
  isExpanded ? (
    <svg data-intro={intro}>
      <use xlinkHref="#chevron-up" />
    </svg>
  ) : (
    <svg data-intro={intro}>
      <use xlinkHref="#chevron-down" />
    </svg>
  );

const filterComponentBodyClasses = (withExpander, isExpanded) =>
  classNames("filter-group__body", {
    "filter-group__body--expander": withExpander,
    "is-expanded": isExpanded,
  });

/**
 * Higher-order component that wraps a component in a filter group UI
 */
const filterComponent = (WrappedComponent) => {
  const FilterComponentWrapper = ({
    heading,
    withExpander = false,
    items = [],
    refine,
    type,
    ...otherProps
  }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const openTab = () => {
      introJs().exit(true);
      setIsExpanded((prev) => !prev);
    };

    const intro =
      heading === "Installation"
        ? "Click here to view and select all the available options"
        : null;

    return (
      <div className="configurator__filter-group filter-group">
        <div className="filter-group__header" onClick={openTab}>
          <h3 className="filter-group__heading">{heading}</h3>
          {withExpander && renderChevron(isExpanded, intro)}
        </div>
        <div className={filterComponentBodyClasses(withExpander, isExpanded)}>
          <WrappedComponent
            heading={heading}
            type={type}
            items={items}
            refine={refine}
            {...otherProps}
          />
        </div>
      </div>
    );
  };

  FilterComponentWrapper.propTypes = {
    heading: PropTypes.string.isRequired,
    type: PropTypes.string,
    withExpander: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.object),
    refine: PropTypes.func,
  };
  return FilterComponentWrapper;
};
export default filterComponent;